import { request } from '@/api/client';
import type {
  Survey,
  SubmitSurveyRequest,
  SubmitSurveyResponse,
  UserSurveyResponsesListResponse,
  UserSurveyResponse,
} from '@/types/survey';

/** Personality-survey endpoints — fetch active survey, submit answers, list user history. */
export const surveyService = {
  getActiveSurvey: (signal?: AbortSignal): Promise<Survey> =>
    request<Survey>('/surveys/active', {
      method: 'GET',
      ...(signal ? { signal } : {}),
    }),

  getSurveyById: (surveyId: string): Promise<Survey> =>
    request<Survey>(`/surveys/${encodeURIComponent(surveyId)}`, {
      method: 'GET',
    }),

  submitSurvey: (data: SubmitSurveyRequest): Promise<SubmitSurveyResponse> =>
    request<SubmitSurveyResponse>('/surveys/submit', {
      method: 'POST',
      body: JSON.stringify(data),
      auth: true,
    }),

  getMySurveyResponses: (): Promise<UserSurveyResponsesListResponse> =>
    request<UserSurveyResponsesListResponse>('/surveys/responses/me', {
      method: 'GET',
      auth: true,
    }),

  getSurveyResponseById: (responseId: string): Promise<UserSurveyResponse> =>
    request<UserSurveyResponse>(`/surveys/responses/${encodeURIComponent(responseId)}`, {
      method: 'GET',
      auth: true,
    }),
};
